import ListOrders from "../../../components/Orders/ListOrders";

export default function Orders() {
    return (
        <div className="Orders">
            <ListOrders></ListOrders>
        </div>
    );
}